export const getUri = (path: string): string => {
  const host = process.env.REACT_APP_BACKEND;

  if (!host) {
    throw new Error('Environment variable REACT_APP_BACKEND undefined!');
  }

  return `${host}/${path}`;
};
